import React from "react";
import styles from "./LoyaltyTierCard.module.css";

interface LoyaltyTierCardProps {
  tier: "bronze" | "silver" | "gold" | "platinum";
  customers: number;
  revenue: number;
}

const tierConfig = {
  bronze: {
    label: "BRONZE TIER",
    color: "#CD7F32",
    icon: "/Bronze Medals with red ribbon.svg",
  },
  silver: {
    label: "SILVER TIER",
    color: "#C0C0C0",
    icon: "/Silver Medals with red ribbon.svg",
  },
  gold: {
    label: "GOLD TIER",
    color: "#FFD700",
    icon: "/Gold Medals with red ribbon.svg",
  },
  platinum: {
    label: "PLATINUM TIER",
    color: "#E5E4E2",
    icon: "/Platinum Medal.svg",
  },
};

const LoyaltyTierCard: React.FC<LoyaltyTierCardProps> = ({
  tier,
  customers,
  revenue,
}) => {
  const config = tierConfig[tier];

  return (
    <div className={styles.card}>
      <div className={styles.iconContainer}>
        <img src={config.icon} alt={config.label} className={styles.icon} />
      </div>
      <div className={styles.content}>
        <div className={styles.tierNameRow}>
          <h4 className={styles.tierName}>{config.label}</h4>
          <span className={styles.revenueLabel}>REVENUE</span>
        </div>
        <div className={styles.stats}>
          <div className={styles.stat}>
            <span className={styles.statValue}>{customers}</span>
            <span className={styles.statLabel}>Customers</span>
          </div>
          <div className={styles.stat}>
            <span className={styles.statValue}>{revenue.toLocaleString()}</span>
            <span className={styles.currency}> EGP</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoyaltyTierCard;
